export default __webpack_public_path__ + "static/contraceptive-method-d2cfb342ae084767e169747e5457dfbf.svg";